/**
 * @module app.shared
 */

import { IApiQueryFilter } from './api-filters';
import { encodeFieldName, encodeStringLiteral, mapQueryComparisonOperator } from './api-utilities';
import { QueryEqualityOperator } from './api-types';

export interface IQueryIdentifierFilterOptions {
    ignoreNullValue: boolean;
    negate: boolean;
    operator: QueryEqualityOperator
}

export class ApiQueryIdentifierFilter implements IApiQueryFilter {

    constructor(public field: string, public value: string, public options: IQueryIdentifierFilterOptions) { }

    public toString(): string {
        const operation = mapQueryComparisonOperator(this.options.operator, this.options.negate);

        const encodedField = encodeFieldName(this.field);
        let encodedValue = 'null';
        if(this.value) {
            encodedValue = this.value.match(/^\d+$/) ?
                this.value :
                encodeStringLiteral(this.value);
        }

        return operation.buildExpression(encodedField, encodedValue);
    }

}


